/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RemoteActionExecutionDeviceResponseDto } from './RemoteActionExecutionDeviceResponseDto';
import type { RemoteActionExecutionJobResponseDto } from './RemoteActionExecutionJobResponseDto';
import type { RemoteActionExecutionStatusDetailsDto } from './RemoteActionExecutionStatusDetailsDto';
export type RemoteActionExecutionResponseDto = {
  id: number;
  status: RemoteActionExecutionResponseDto.status;
  job: RemoteActionExecutionJobResponseDto;
  completedAt?: string;
  device?: RemoteActionExecutionDeviceResponseDto;
  updatedAt: string;
  createdAt: string;
  statusDetails?: RemoteActionExecutionStatusDetailsDto;
};
export namespace RemoteActionExecutionResponseDto {
  export enum status {
    QUEUED = 'QUEUED',
    IN_PROGRESS = 'IN_PROGRESS',
    SUCCEEDED = 'SUCCEEDED',
    FAILED = 'FAILED',
    TIMED_OUT = 'TIMED_OUT',
    REJECTED = 'REJECTED',
    DELETED = 'DELETED',
    REMOVED = 'REMOVED',
    CANCELED = 'CANCELED',
  }
}

